// Helper function to create elements with options

window.createElement = (tag, options = {}) => {
    const element = document.createElement(tag)

    Object.entries(options).forEach(([key, value]) => {
        if (key === "classList" && Array.isArray(value)) {
            element.classList.add(...value)

        } else if (key === "dataset" && typeof value === "object") {
            Object.assign(element.dataset, value)

        } else if (key === "events" && typeof value === "object") {
            Object.entries(value).forEach(([event, handler]) => {
                element.addEventListener(event, handler)
            })

        } else {
            element[key] = value
        }
    })

    return element
}
